import { render, staticRenderFns } from "./PageLogin.vue?vue&type=template&id=5603285b&scoped=true"
import script from "./PageLogin.vue?vue&type=script&lang=js"
export * from "./PageLogin.vue?vue&type=script&lang=js"
import style0 from "./PageLogin.vue?vue&type=style&index=0&id=5603285b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603285b",
  null
  
)

export default component.exports